import React, { FC } from "react";
import { RouteComponentProps } from "react-router";
import { Redirect, Route, Switch } from "react-router-dom";
import Header from "go-app/components/Header";
import SubmenuDiagnosticNavigation from "./components/SubmenuDiagnosticNavigation";
import OrganizationSettingsDiagnosticOpenAmountPage from "./pages/OpenAmount";
import OrganizationSettingsDiagnosticProductOpenAmountPage from "./pages/OpenAmountProduct";
import OrganizationSettingsDiagnosticProductTransactionsPage from "./pages/ProductTransactions";

const OrganizationSettingsDiagnosticPage: FC<RouteComponentProps> = (props) => {
	return (
		<div className="content">
			<Header title={"Narzędzia diagnostyczne"} />
			<SubmenuDiagnosticNavigation />
			<Switch>
				<Route
					path={`${props.match.url}/report-open-amount`}
					component={OrganizationSettingsDiagnosticOpenAmountPage}
				/>
				<Route
					path={`${props.match.url}/product/open-amount`}
					component={OrganizationSettingsDiagnosticProductOpenAmountPage}
				/>
				<Route
					path={`${props.match.url}/product/transactions`}
					component={OrganizationSettingsDiagnosticProductTransactionsPage}
				/>
				<Redirect from={props.match.url} exact to={props.match.url + "/report-open-amount"} />
			</Switch>
		</div>
	);
};

export default OrganizationSettingsDiagnosticPage;
